
<template>
  <div class="box">
    <p class="login_title" v-if="!showPhoneDialog">{{$t('m.scan_code')}}</p>
    <scan :agreeXieyi="agreeXieyi" :type="1" v-if="!showPhoneDialog" @showBindDialog="showBindDialog" ref="qcode"></scan>
    <bind-phone-pwd v-if="showPhoneDialog" ref="phonePwd" @cancelSet="cancelSet"/>
  </div>
</template>
<script>

import scan from "../scan";
import bindPhonePwd from "@/components/login/bindPhonePwd";
export default {
  components: {
    "scan": scan, bindPhonePwd
  },
  props:{
    agreeXieyi: {
      type: Boolean,
      default () {
        return false;
      }
    },
  },
  data() {
    return {
      showPhoneDialog: false
    };
  },
  mounted() {

  },
  methods: {
    cancelSet() {
      this.showPhoneDialog = false
    },
    /**
     * 刷新二维码
     */
    updateCode() {
      this.$refs.qcode.getQrcodeInfo()
    },
    showBindDialog(data) {
      this.showPhoneDialog = true
      this.$nextTick(() => {
        this.$refs.phonePwd.showDialog(data)
      })
    }

  },
};
</script>
<style lang="less" scoped>

.box{font-size: .14rem;}

.box {
  width: 80%;
  max-width: 400px;
  margin: 0 auto;
}
.login {
  &_title {
    font-size: .3rem;
    text-align: center;
    padding:.67rem 0 .48rem;
  }
}

@media only screen and (max-width: 767px) {
  .login_title{
    padding: .38rem 0 .48rem;
    font-size: .4rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/login/scanLogin.vue